import { render, staticRenderFns } from "./ContractModule.vue?vue&type=template&id=0c1a57bd&"
import script from "./ContractModule.vue?vue&type=script&lang=ts&"
export * from "./ContractModule.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports